const initialState = {
    filters: [],
    products: [],
    productCount: 0,
    seller: {},
    catPath: [],
};

const categoryProducts = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_CATEGORY_PRODUCTS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default categoryProducts;
